/** @format */

const template = `
<div class="prerequisite-group-container" ng-repeat="prerequisiteGroup in $ctrl.prerequisites">
  <div class="grouping-panel">
    <h4 translate="STUDIES.PREREQUISITES_EDITOR.PREREQUISITE_GROUP" translate-value-index="{{$index + 1}}"></h4>
    <div ng-repeat="prerequisite in prerequisiteGroup.prerequisites" class="prerequisites">
      <sis-course-unit-box
        ng-if="prerequisite.type === 'CourseUnit' && $ctrl.courseUnitsByGroupId[prerequisite.courseUnitGroupId]"
        [course-unit]="$ctrl.courseUnitsByGroupId[prerequisite.courseUnitGroupId]"></sis-course-unit-box>
      <sis-module-box
        ng-if="prerequisite.type === 'Module' && $ctrl.modulesByGroupId[prerequisite.moduleGroupId]"
        [module]="$ctrl.modulesByGroupId[prerequisite.moduleGroupId]"></sis-module-box>
    </div>
  </div>
  <h4 ng-if="!$last" translate>STUDIES.COURSE_UNIT_INFO_MODAL.OR</h4>
</div>
`;
export default template;
